<div class="spinner-container">
  @switch (themeType) {
    <!-- light-genius theme spinner -->
    @case ('light-genius') {
      <div class="spinner-box spinner-box--image">
        <img src="assets/img/light-genius-loading.svg" alt="loading" />
      </div>
    }
    <!-- dark theme spinner -->
    @default {
      <div class="spinner-box">
        <div class="spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="message">{{ message }}</div>
    }
  }
</div>
